import React, { useEffect, useState } from "react";
import "./BlogDetail.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { motion } from "framer-motion";
import Adelaidebanner from "../Assets/Blog/about-us-banner-img.png";
import blogImage from "../Assets/Blog/blog-banner-img.jpg";
import { Link } from "react-router-dom";
import api, { PUBLIC_BASE_URL, BASE_URL } from "../Api/api";
import { useParams } from "react-router-dom";

const BlogDetail = ({ blogId }) => {
  const { id } = useParams(); // ✅ Get blog ID from route
  const [details, setDetails] = useState([]);

  useEffect(() => {
    api
      .get(`blog-details-by-blog/${id}`) // ✅ Use 'id' instead of undefined blogId
      .then((response) => {
        setDetails(response.data);
      })
      .catch((error) => {
        console.error("Error fetching blog details:", error);
      });
  }, [id]);

  return (
    <div>
      <Header />

      <section
        className="hero-section py-24 text-white text-center relative"
        style={{
          background: `url(${Adelaidebanner}) center/cover`,
          position: "relative",
        }}
      >
        <div
          className="container mx-auto px-4 relative z-10"
          style={{ marginTop: "10%" }}
        >
          <motion.h1
            className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4"
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Blog Details
          </motion.h1>

          <motion.p
            className="text-lg"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            Home / Read More
          </motion.p>
        </div>

        {/* Optional Overlay */}
        <div className="absolute inset-0 bg-black opacity-40 z-0"></div>
      </section>

      <section className="blog-container mb-5">
        <div className="container">
          {details.length > 0 && (
            <>
              {/* Show image, heading, date once */}
              <div className="blog-image-wrapper position-relative rounded overflow-hidden shadow mb-5">
                <img
                  src={`${PUBLIC_BASE_URL}${details[0].image}`}
                  alt={details[0].heading}
                  className="img-fluid w-100"
                  style={{ height: "500px", objectFit: "cover" }}
                />
                <div className="position-absolute top-0 start-0 w-100 h-100 px-3 px-lg-5 py-4 bg-dark bg-opacity-50">
                  <div className="row w-100">
                    <div className="col-lg-1 col-md-4 d-flex justify-content-start">
                      <div className="blog-date bg-white text-primary fw-bold px-3 py-2 rounded shadow-sm text-center">
                        <div className="fs-3">
                          {new Date(details[0].date).getDate()}
                        </div>
                        <div className="text-uppercase fs-6">
                          {new Date(details[0].date).toLocaleString("default", {
                            month: "short",
                          })}
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-11 col-md-8 text-white">
                      <div className="bg-dark bg-opacity-50 p-3 rounded">
                        <h2 className="fw-bold mb-0">{details[0].heading}</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Only show title/description loop */}
              <div className="blog-content mt-4">
                {details.map((detail, index) => (
                  <div key={index} className="mb-4">
                    <h3>{detail.title}</h3>
                    <span
  className="d-block fs-5 fw-normal mt-2"
  dangerouslySetInnerHTML={{
    __html: detail.description,
  }}
></span>

                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogDetail;
